export default __webpack_public_path__ + "static/media/SecondaryLocation.6a60f03b.svg";